// import React from 'react';
// import { AcademicCapIcon, ClipboardDocumentCheckIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';

// const steps = [
//   {
//     title: "1. Register Your School",
//     description: "Begin by creating your school profile with basic details.",
//     icon: <AcademicCapIcon className="h-10 w-10 text-indigo-500" />,
//   },
//   {
//     title: "2. Set Up Users",
//     description: "Add administrators, teachers, students, and staff easily.",
//     icon: <ClipboardDocumentCheckIcon className="h-10 w-10 text-indigo-500" />,
//   },
//   {
//     title: "3. Launch and Monitor",
//     description: "Access dashboards, manage schedules, and monitor progress.",
//     icon: <RocketLaunchIcon className="h-10 w-10 text-indigo-500" />,
//   },
// ];

// const HowToGetStarted = () => {
//   return (
//     <section className="bg-white text-gray-800 py-20 px-6 md:px-16">
//       <div className="max-w-7xl mx-auto text-center">
//         <h2 className="text-4xl font-bold mb-4">How to Get Started</h2>
//         <p className="text-gray-600 mb-12 text-lg">
//           Follow these 3 simple steps to launch your school ERP platform.
//         </p>

//         <div className="grid gap-10 sm:grid-cols-1 md:grid-cols-3">
//           {steps.map((step, idx) => (
//             <div
//               key={idx}
//               className="bg-gray-50 p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
//             >
//               <div className="mb-4 flex justify-center">{step.icon}</div>
//               <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
//               <p className="text-gray-600">{step.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HowToGetStarted;


import React from 'react';
import {
  AcademicCapIcon,
  ClipboardDocumentCheckIcon,
  RocketLaunchIcon,
} from '@heroicons/react/24/outline';

const steps = [
  {
    title: "1. Register Your School",
    description: "Begin by creating your school profile with basic details.",
    icon: <AcademicCapIcon className="h-10 w-10 text-indigo-400" />,
  },
  {
    title: "2. Upload Documents",
    description: "Submit key documents to get your school ready for launch.",
    icon: <ClipboardDocumentCheckIcon className="h-10 w-10 text-indigo-400" />,
  },
  {
    title: "3. Launch and Monitor",
    description: "Access dashboards, manage schedules, and monitor progress.",
    icon: <RocketLaunchIcon className="h-10 w-10 text-indigo-400" />,
  },
];

const HowToGetStarted = () => {
  return (
    <section className="bg-gradient-to-r from-[#1e293b] via-[#0f172a] to-[#1e293b] text-white py-20 px-6 md:px-16">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-4">🚀 How to Get Started</h2>
        <p className="text-gray-300 mb-12 text-lg max-w-2xl mx-auto">
          Follow these 3 simple steps to launch your school on <span className="text-indigo-400 font-medium">Isnartech ERP</span> platform.
        </p>

        <div className="grid gap-10 sm:grid-cols-1 md:grid-cols-3">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className="bg-[#1f2937] p-8 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border border-slate-700"
            >
              <div className="mb-4 flex justify-center">{step.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-white">{step.title}</h3>
              <p className="text-gray-400">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToGetStarted;
